import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthContext";

const BACKEND_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminStats = () => {
  const { token } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/admin/stats`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch admin statistics");
        }

        const data = await response.json();
        setStats(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [token]);

  if (loading) return <p style={{ textAlign: "center", padding: "20px" }}>Loading statistics...</p>;
  if (error) return <p style={{ color: "red", textAlign: "center" }}>Error loading stats: {error}</p>;

  return (
    <div className="stats-container">
      <h1 className="title-blue">Platform Overview & Statistics</h1>

      <div className="dashboard-container">
        <div className="card">
          <img src="/mainImages/admin/user.png" alt="Total Users" className="admin-icons" />
          <h3>Total Registered Users</h3>
          <p className="green-card">{stats.totalUsers || 0}</p>
        </div>

        <div className="card">
          <img src="/mainImages/admin/user.png" alt="Business Accounts" className="admin-icons" />
          <h3>Business Accounts</h3>
          <p className="green-card">{stats.businessUsers || 0}</p>
        </div>

        <div className="card">
          <img src="/mainImages/admin/active.png" alt="Total Licenses" className="admin-icons" />
          <h3>Total Licenses Generated</h3>
          <p className="green-card">{stats.totalLicenses || 0}</p>
        </div>

        <div className="card">
          <img src="/mainImages/admin/active.png" alt="Active Licenses" className="admin-icons" />
          <h3>Active Licenses</h3>
          <p className="green-card">{stats.activeLicenses || 0}</p>
        </div>

        <div className="card">
          <img src="/mainImages/admin/inactive.png" alt="Inactive Licenses" className="admin-icons" />
          <h3>Inactive / Disabled</h3>
          <p className="red-card">{(stats.totalLicenses || 0) - (stats.activeLicenses || 0)}</p>
        </div>

        <div className="card">
          <img src="/mainImages/admin/game_count.png" alt="Plays Consumed" className="admin-icons" />
          <h3>Total Plays Consumed</h3>
          <p className="green-card">{stats.totalPlaysUsed || 0}</p>
        </div>
      </div>
    </div>
  );
};

export default AdminStats;